var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1771 15.9978V23.6123H7.66525H7.56271V23.7148V25.7657V25.8682H7.66525H18.9449H19.0474V25.7657V23.7148V23.6123H18.9449H14.433V15.9978L25.6859 3.67326L25.7127 3.64389V3.60412V0.642822V0.54028H25.6102H1H0.897458V0.642822V3.60412V3.64389L0.924274 3.67326L12.1771 15.9978ZM3.17835 2.79621H23.4318L20.3422 6.18011H6.26797L3.17835 2.79621ZM8.32771 8.43604H18.2824L13.3202 13.8708H13.2899L8.32771 8.43604Z",
    fill: "#FCC436",
    stroke: "#FCC436",
    strokeWidth: 0.205085
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3051 17.0496L6.20076 7.82078L20.4094 7.82078L13.3051 17.0496Z",
    fill: "#FCC436"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinkIcon);
export default __webpack_public_path__ + "static/media/DrinkIcon.2e7677a75b8ff5ee8733ac788566684e.svg";
export { ForwardRef as ReactComponent };